import { Box, Typography } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

export default function PermissaoTelaVazia() {
    return (
        <Box
            width="100%"
            height="70%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            gap={1}
        >
            <InfoIcon fontSize="large" sx={{color: "gray"}}/>

            <Typography
                color="gray"
            >
                Você não tem permissão para visualizar essa página
            </Typography>
        </Box>
    )
}